import DashboardLayout from "layout/DashboardLayout/DashboardLayout";
import React from "react";

export default function AchievementsPage() {
  return <DashboardLayout>This is achievements page.</DashboardLayout>;
}
